import type {
  PartnerRule,
  PartnerRuleCreate,
  PartnerRuleCriterionDefinition,
  PartnerRulePropertyInfo,
  PartnerRuleUpdate,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const rules = {
  search: {
    queryKey: 'partner-management-service/rules',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerRule[]>(`/partner-management-proxy/api/v1/partners/rules`);
      return data;
    },
  },
  rulePropertyInfos: {
    queryKey: 'partner-management-service/rules/rule-property-infos',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerRulePropertyInfo[]>(
        `/partner-management-proxy/api/v1/partners/rules/rulePropertyInfos`,
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/rules/id',
    configurationType: 'no-cache' as const,
    fn: async (ruleId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerRule>(
        `/partner-management-proxy/api/v1/partners/rules/${ruleId}`,
      );

      return data;
    },
  },
  create: async (payload: PartnerRuleCreate) => {
    const { data } = await GatewayAxiosClient.post(`/partner-management-proxy/api/v1/partners/rules`, payload);
    return { data, invalidateQueryKeys: [['partner-management-service/rules']] };
  },
  update: async ({ ruleId, payload }: { ruleId: string; payload: PartnerRuleUpdate }) => {
    const { data } = await GatewayAxiosClient.put<PartnerRule>(
      `/partner-management-proxy/api/v1/partners/rules/${ruleId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [['partner-management-service/rules']],
      updateQueryData: [
        {
          queryKey: ['partner-management-service/rules/id', ruleId],
          data,
        },
      ],
    };
  },
  buildUpdatePayloadFromRule: (rule: PartnerRule): PartnerRuleUpdate => {
    return {
      active: rule.active!,
      archived: rule.archived!,
      carrierAndServiceMethodList: rule.carrierAndServiceMethodList,
      listType: rule.listType,
      name: rule.name,
      description: rule.description,
      tenantIds: rule.tenantIds,
      terminating: rule.terminating,
      criteria: rule.criteria.map<PartnerRuleCriterionDefinition>((criteria) => {
        return {
          compareValue: criteria.compareValue!,
          ruleComparatorEnum: criteria.ruleComparator.ruleComparatorEnum!,
          rulePropertyEnum: criteria.ruleProperty.rulePropertyEnum!,
          scalarUnitEnum: criteria?.scalarUnit?.scalarUnitEnum,
        };
      }),
    };
  },
};
